import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const blogs = [
  {
    img: "/images/keyword/1.jpg",
    title: "Pune to Mumbai Cabs – Comfort & Convenience",
    description:
      "Explore hassle-free travel from Pune to Mumbai with our reliable cab service. Affordable, punctual, and comfortable for both business and leisure.",
    link: "Pune-to-Mumbai-Cab",
  },
  {
    img: "/images/newimages/7.jpg",
    title: "Plan a Spiritual Trip to Shirdi with Sai Trupti Cabs",
    description:
      "Book a cab to Shirdi and enjoy a peaceful, budget-friendly pilgrimage experience with experienced drivers and clean vehicles.",
    link: "Pune-to-Shirdi-Cab",
  },
  {
    img: "/images/keyword/3.jpg",
    title: "24/7 Pune Airport Pickup & Drop Cabs",
    description:
      "Get on-time cab service to and from Pune airport with our 24/7 operations, professional chauffeurs, and seamless online booking.",
    link: "Pune-to-Mumbai-International-Airport-Cab",
  },
  {
    img: "/images/keyword/52.jpg",
    title: "Weekend Getaway from Pune to Goa with Sai Trupti Cabs",
    description:
      "Relax and unwind at Goa beaches with our comfortable Pune to Goa cab services — perfect for family trips, friends’ outings, and couples.",
    link: "Pune-to-Goa-Cab",
  },
  {
    img: "/images/keyword/35.jpg",
    title: "Enjoy Scenic Drives to Mahabaleshwar",
    description:
      "Book a Pune to Mahabaleshwar cab and experience the lush green hills, strawberry farms, and breathtaking viewpoints with Sai Trupti Cabs.",
    link: "Pune-to-Mahabaleshwar-Cabs",
  },
];

const BlogSection = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 800,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="blog-section">
      <div className="container">
        <div className="section-title text-center">
          <span className="sub-title">SAI TRUPTI CABS</span>
          <h2 className="title">Our Blogs</h2>
        </div>

        <Slider {...settings}>
          {blogs.map((blog, index) => (
            <div key={index} className="blog-card">
              <div className="blog-img-box">
                <img src={blog.img} alt={blog.title} className="blog-img" />
              </div>
              <div className="blog-content">
                <span className="badge">Sai Trupti Cabs</span>
                <h4>{blog.title}</h4>
                <p>{blog.description}</p>
                <a href={blog.link} className="read-more">
                  Read More →
                </a>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default BlogSection;
